import classNames from 'classnames';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './index.less';

export interface IFontIconProps {
    name: string;
    fontSize?: number;
    isActive?: boolean;
    disable?: boolean;
    color?: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    type?: string;
    width?: number;
    height?: number;
    borderRadius?: number;
    marginBottom?: number;
    text?: string;
    textSize?: number;
    minWidth?: number;
    vertical?: boolean;
    style?: React.CSSProperties;
}

const FontIconBtn = ({
    name,
    color,
    fontSize = 12,
    isActive = false,
    disable = false,
    width = 34,
    height = 34,
    borderRadius = 8,
    marginBottom = 0,
    text = '',
    textSize = 12,
    minWidth = 50,
    onClick,
    type,
    vertical = false,
    style: customStyle = {},
}: IFontIconProps) => {
    let style: React.CSSProperties = {};

    if ((type === 'button' && !text) || type === 'menu') {
        style = { width, height, borderRadius, marginBottom };
    } else if (type === 'button' && text) {
        style = { borderRadius, marginBottom, minWidth };
    }

    return (
        <div
            style={{
                ...customStyle,
                ...style,
            }}
            className={classNames({
                'font-icon-btn': type === 'button',
                'font-icon-btn__vertical': type === 'button' && vertical,
                'font-icon-btn__active': type === 'button' && isActive,
                'font-icon-btn__disable': type === 'button' && disable,
                'font-icon-menu': type === 'menu',
                'font-icon-menu__active': type === 'menu' && isActive,
                'font-icon-btn__wrap': type === 'button',
            })}
            onClick={(e) => {
                if (onClick && !disable) {
                    onClick(e);
                }
            }}
        >
            <IconFont
                name={name}
                className={classNames({
                    'b-icon-font': true,
                    'b-icon-font__active': isActive,
                    'b-icon-font__disable': disable,
                })}
                fontSize={fontSize}
                color={color}
            />
            {type === 'button' && text ? (
                <div style={{ fontSize: textSize }} className="font-icon-btn__text">
                    {text}
                </div>
            ) : null}
            {type === 'menu' ? <div className="font-icon-menu__text">{text}</div> : null}
        </div>
    );
};

export default FontIconBtn;
